import { defineComponent as _defineComponent } from 'vue'
import BendOverview from '@/views/workcenterConsole/bend/BendOverview.vue';
import BendSummary from '@/views/workcenterConsole/bend/BendSummary.vue';
import BendIntradayAvailability from '@/views/workcenterConsole/bend/BendIntradayAvailability.vue';
import BendProductionHistory from '@/views/workcenterConsole/bend/BendProductionHistory.vue';
import BendTrends from '@/views/workcenterConsole/bend/BendTrends.vue';
import BendNewTrends from './BendNewTrends.vue';
import NewFeatureBadge from '@/components/NewFeatureBadge.vue';
import { BendLayoutTab } from '@/components/common/BendLayoutTab';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { computed, ref, watch } from 'vue';
import { currentUser } from '@/utils/permissionUtils';
import { BetaFeature } from '@/models/enums/BetaFeature';
import { useI18n } from '@/composables/i18n';
import { BendTrendMode } from '@/models/enums/BendTrendMode';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendLayout',
  props: {
    activeTab: null,
    selectedDevices: null,
    selectedDateRange: null,
    selectedTimespan: null,
    selectedShifts: null,
    selectedTimeAxisSpan: null,
    selectedBendTrendMode: null
  },
  emits: ["change:tab"],
  setup(__props: any, { emit }: { emit: ((e: 'change:tab', tab: BendLayoutTab) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  activeTab: BendLayoutTab;
  selectedDevices: string[];
  selectedDateRange: [Date, Date];
  selectedTimespan: FilterTimeSpanEnum;
  selectedShifts: number[];
  selectedTimeAxisSpan: FilterTimeAxisSpanEnum;
  selectedBendTrendMode: BendTrendMode;
};





const activeTabInternal = ref(BendLayoutTab.BendOverview);

const { t } = useI18n();

function onTabChanged(tab: BendLayoutTab) {
  emit('change:tab', tab);
}

function changeToTab(tab: BendLayoutTab) {
  activeTabInternal.value = tab;
  onTabChanged(tab);
}

watch(
  () => props.activeTab,
  () => {
    activeTabInternal.value = props.activeTab;
  },
  { immediate: true },
);

const hasBendBetaFeature = computed<boolean>(() =>
  currentUser().hasBetaFeature(BetaFeature.WorkCenterConsoleBend),
);

watch(hasBendBetaFeature, (isBetaEnabled, wasBetaEnabled) => {
  if (wasBetaEnabled && !isBetaEnabled) {
    if (
      props.activeTab === BendLayoutTab.BendSummary ||
      props.activeTab === BendLayoutTab.BendIntradayAvailability ||
      props.activeTab === BendLayoutTab.BendProductionHistory
    ) {
      changeToTab(BendLayoutTab.BendOverview);
    }
    if (props.activeTab === BendLayoutTab.BendNewTrends) {
      changeToTab(BendLayoutTab.BendTrends);
    }
  } else if (props.activeTab === BendLayoutTab.BendOverview) {
    changeToTab(BendLayoutTab.BendSummary);
  } else if (props.activeTab === BendLayoutTab.BendTrends) {
    changeToTab(BendLayoutTab.BendNewTrends);
  }
});

return { __sfc: true,props, emit, activeTabInternal, t, onTabChanged, changeToTab, hasBendBetaFeature, BendOverview, BendSummary, BendIntradayAvailability, BendProductionHistory, BendTrends, BendNewTrends, NewFeatureBadge, BendLayoutTab }
}

})